import {

  EnvelopeIcon,
  PhoneIcon,
  MapPinIcon,
} from "@heroicons/react/24/solid"; 
import './contact.css';

function ContactCard({ icon: Icon, title, children }) {
  return (
    <div className="contact-card">
      <div className="contact-card-content">
        <div className="contact-icon-wrapper">
          <Icon className="contact-icon" />
        </div>
        <div>
          <h3 className="contact-card-title">
            {title}
          </h3>
          <div className="contact-card-text">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default function Contact({ PNG }) {
  return (
    <main className="contact-page-main">
      {/* ===== Background layers (gradient + responsive image) ===== */}
      {/* <div className="background-layers">
        <div className="background-gradient" />
        <div
          className="background-image"
          style={{ backgroundImage: `url(${PNG?.bg})` }}
        />
      </div> */}

      {/* ===== Main Content ===== */}
      <div className="contact-main-content">
        {/* Cards */}
        <section className="contact-cards-grid">
          <ContactCard icon={EnvelopeIcon} title="Email">
            <p className="font-medium">iitwomenfacultymeet@iitd.ac.in</p>
            <p className="subtext">For all event-related communication</p>
          </ContactCard>

          <ContactCard icon={PhoneIcon} title="Phone">
            <p className="font-medium">011 2659 7367</p>
            <p className="subtext">Mon–Fri, 9:00 AM – 5:30 PM</p>
          </ContactCard>

          <ContactCard icon={MapPinIcon} title="Address">
            <p>LH301, Office of Academic Outreach & New Initiatives</p>
            <p>Academic Complex, IIT Delhi, Hauz Khas, <br /> New Delhi- 110016</p>
          </ContactCard>
        </section>

        {/* Map */}
        <section className="contact-map-section">
          <h2 className="contact-map-heading">
            <MapPinIcon className="contact-map-icon" />
            Find us on the map
          </h2>
          <div className="contact-map-frame-wrapper">
            <iframe
              src="https://www.google.com/maps?q=Academic+Outreach+Office,+IIT+Delhi&output=embed"
              title="Map of IIT Delhi"
              width="100%"
              height="420"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </section>
      </div>
    </main>
  );
}